import { render, staticRenderFns } from "./IconCross.vue?vue&type=template&id=28353ff4&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconCross.vue"
export default component.exports